// eslint-disable-next-line import/prefer-default-export
export const onlyDigits = (input: string | number) => /^[0-9]+$/.test(input.toString());
